export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";